import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <span className="footer-text">© {currentYear} 주식회사 갤럭시웨일</span>
        <span className="footer-divider">•</span>
        <span className="footer-text">대표 : 홍선형</span>
        <span className="footer-divider">•</span>
        <span className="footer-text">사업자 등록번호 : 629-88-03524</span>
        <span className="footer-divider">•</span>
        <Link to="/privacy" className="footer-link">개인정보처리방침</Link>
        <span className="footer-divider">•</span>
        <Link to="/terms" className="footer-link">이용약관</Link>
        <span className="footer-divider">•</span>
        <div className="footer-social-links">
          <a 
            href="mailto:contact@latteis.com" 
            className="footer-icon-link"
            title="이메일 문의"
            aria-label="이메일 문의"
          >
            <Mail className="w-4 h-4" />
          </a>
          <a 
            href="https://www.linkedin.com/company/latteis" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-icon-link linkedin-icon"
            title="LinkedIn"
            aria-label="LinkedIn 페이지"
          >
            <svg 
              className="w-4 h-4" 
              viewBox="0 0 24 24" 
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
        </div>
      </div>
      {/* SEO를 위한 숨김 텍스트 */}
      <div style={{position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden'}}>
        라떼이즈닷컴 latteis.com 라떼이즈 AI 이력서 컨설팅 플랫폼
      </div>
    </footer>
  );
};

export default Footer;